import Vue from 'vue'
import Router from 'vue-router'
// page router
import { routes as login } from '@/components/0-login/login.js'
Vue.use(Router)

const router = new Router({
  linkActiveClass: 'active',
  routes: [
    // ...errorRoute,
    ...login
    // ...completeRoute,
    // test
  ]
})
// 路由拦截
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    window.document.title = to.meta.title
  } else {
    window.document.title = window.baseName
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/login.js